import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import { IHttpPost } from 'interfaces/index';

function getTransformResponse() {
  return [(response) => response];
}

function parseResponse(res: AxiosResponse): Promise<any> {
    const response = res.data; 
    if (response) {
      try {
        if (!response || response.trim() === "undefined") return null;
        const parsedResult = JSON.parse(response)?.result || null; 
        return parsedResult;
      } catch (error) {
        throw new Error(`Unable to parse response from server: ${error.message}`);
      }
    }
    
    if (response && !response.success) {
      throw new Error(JSON.stringify(response));
    }
} 

export async function post({ url, body, rpc = true }: IHttpPost): Promise<any> {
  if (rpc) {
    body.jsonrpc = body.jsonrpc || '2.0';
    body.id = body.id || 2
  }

  const options: AxiosRequestConfig = {
    method: 'POST',
    url,
    headers: { 'Content-Type': 'application/json' },
    data: JSON.stringify(body),
    transformResponse: getTransformResponse(),
    validateStatus: _ => {
      return true;
    }
  };
  const res = await axios.request(options);
  return parseResponse(res);
};

export async function get({ url }): Promise<any> {
  const options: AxiosRequestConfig = {
    method: 'GET',
    url
  };
  const result = await axios(options);
  try {
    return result?.data?.result;
  } catch (error) {
    return result
  }
  
};
export async function getHttp({ url }): Promise<any> {
  const result = await axios.get(url);
  return result.data;
}